// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeLayout_root__1II39","content":"HomeLayout_content__1UrL6","header":"HomeLayout_header__22F0c","date":"HomeLayout_date__2tLgj","welcome":"HomeLayout_welcome__4CcKh"};